import { Button, Modal, Text } from '@fozito/common-ui';
import { Form, Input, InputRef } from 'antd';
import FormItemValue from 'components/FormItemValue';
import { delay } from 'lodash';
import NumberPadV2 from 'modules/POS/Cashier/components/NumberPad';
import shopApis from 'modules/shop/services/apis';
import { IStaffItem } from 'modules/shop/types/staff';
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { IResponseData } from 'services/response';
import styled from 'styled-components';
import { setPageLoading } from 'widgets/PageLoading';
const FormStyled = styled(Form)`
display: flex;
flex-direction: column;
`;
type Props = {};
type Ref = {
  open: (callback: (staffData: IStaffItem) => void, type?: 'ADMIN' | 'MANAGER' | 'CASHIER') => void;
  openReturn: (callback: (staffData: IStaffItem) => void, configs?: { title?: string }) => void;
};
export const PIN_LENGTH = 6;
export const useModalCheckPasscodeRef = () => useRef<Ref>(null);
export const globalModalCheckPasscodeRef = React.createRef<Ref>();
export const verifyPasscode: Ref['open'] = (cb, type) => globalModalCheckPasscodeRef.current?.open(cb, type);
export const verifyPasscodeWithConfig: Ref['openReturn'] = (cb, configs) => globalModalCheckPasscodeRef.current?.openReturn(cb, configs);

const ModalCheckPasscode = forwardRef<Ref, Props>(({ }, ref) => {
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState<string>('');
  const callbackRef = useRef<(staffData: IStaffItem) => void>(() => undefined);
  const inputRef = useRef<InputRef>(null);

  const onClose = () => setOpen(false);

  const handleOpen = (staffType?: string) => {
    form.resetFields();
    setOpen(true);
    delay(() => inputRef.current?.focus(), 100);
    form.setFieldValue('staffType', staffType);
    switch (staffType) {
      case 'ADMIN':
        setTitle('Admin Pin Code');
        break;
      case 'MANAGER':
        setTitle('Manager Pin Code');
        break;
      default:
        setTitle('Pin Code');
        break;
    }
  };

  const onOpen: Ref['open'] = (_callback, staffType) => {
    handleOpen(staffType);
    callbackRef.current = _callback || (() => undefined);
  };
  const openReturn: Ref['openReturn'] = (_callback, configs) => {
    handleOpen();
    if (configs?.title)
      setTitle(configs?.title);
    callbackRef.current = _callback || (() => undefined);
  };

  const onValuesChange = (changedValues: any) => {
    if (changedValues.code && changedValues.code.length === 6) {
      form.submit();
    }
  };

  const handleFinish = async (values: { code: string, staffType?: string }) => {
    setPageLoading(true);
    try {
      const res: IResponseData<IStaffItem> = values.staffType === 'ADMIN' ? await shopApis.checkAdminPassCode(values.code) : await shopApis.checkPassCode(values.code);
      if (res.data.data) {
        if (values.staffType) {
          if (values.staffType !== res.data.data.staffType) {
            form.setFieldsValue({ msg: 'Staff does not exits' });
            callbackRef.current(res.data.data);
            return;
          }
        }
        onClose();
        callbackRef.current(res.data.data);
        return;
      }
    } catch (error) {
      form.setFieldsValue({ msg: 'Staff does not exits' });
    } finally {
      setPageLoading(false);
    }
  };


  useImperativeHandle(ref, () => ({
    open: onOpen,
    openReturn,
  }));

  return (
    <Modal title={title} isOpen={open} onClose={onClose}>
      <FormStyled<any> form={form} onFinish={handleFinish}
        onValuesChange={onValuesChange}
        initialValues={{ code: '' }}>
        <InputUIV2>
          <Form.Item name='code' noStyle>
            <Input
              ref={inputRef}
              name="input_password"
              autoFocus
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              placeholder='..'
              inputMode='none'
              className={'password-input'}
              maxLength={PIN_LENGTH}
              autoComplete="off"
            />
          </Form.Item>
        </InputUIV2>
        <FormItemValue name={'msg'} render={(msg) => <MsgStyled>{msg}</MsgStyled>} />
        <Form.Item name='code' noStyle>
          <NumberPadV2
            controlRef={inputRef}
            type='PIN-PASSWORD'
            maxLength={PIN_LENGTH}
          />
        </Form.Item>
        <Form.Item name='staffType' noStyle />
        <Button onClick={onClose} type_cancel block style={{ margin: '0 16px', marginBottom: '16px' }}>Close</Button>
      </FormStyled>
    </Modal>
  );
});
ModalCheckPasscode.displayName = 'ModalCheckPasscode';
export default ModalCheckPasscode;
const MsgStyled = styled(Text)`
color: #D2464F;
font-family: Poppins;
font-size: 18px;
font-style: normal;
font-weight: 400;
line-height: normal;
align-self: stretch;
text-align: center;
`;

const InputUIV2 = styled.div`
align-self: stretch;
  display: flex;
  flex-direction: column;
  background: #fff;
  padding: 16px 0;
  .password-input {
    -webkit-text-security: disc;
    text-security: disc;
    &.scanQR {
      input {
        text-align: center;
        padding-left: 50px;
      }
    }
  }
input {
  color: #D2464F;
  flex: 1;
  text-align: center;
  font-family: Poppins;
  font-size: 45px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}
`;